import { render } from "./holidays-list.vue?vue&type=template&id=68b36253"
import script from "./holidays-list.vue?vue&type=script&lang=js"
export * from "./holidays-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__